import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { BaseResourceItemsComponent, EddyAutoComplete, Favorecido, FavorecidoService, FuncaoService, GlobalService, Rcms, RcmsFavorecido, RcmsItem } from 'eddydata-lib';
import { link } from 'fs';
import { AutoComplete } from 'primeng/autocomplete';
import * as toastr from 'toastr';
import { RcmsFavorecidorService } from '../service/rcms-favorecido.service';


declare var $: any;

@Component({
  selector: 'app-rcms-favorecido',
  templateUrl: './rcms-favorecido.component.html'
})
export class RcmsFavorecidoComponent extends BaseResourceItemsComponent<RcmsFavorecido> implements OnChanges {

  @Input() itens: RcmsItem[] = [];

  @Input() somenteVisualizar: boolean = false;

  @Input() rcms: Rcms;

  @ViewChild('favorecido') favorecidoInput: AutoComplete;

  public favorecidoAutoComplete: EddyAutoComplete<Favorecido>;

  public favorecidoEdit: RcmsFavorecido;

  constructor(private favorecidoService: FavorecidoService,
    public funcaoService: FuncaoService,
    public globalService: GlobalService,
    public rcmsFavorecidoService: RcmsFavorecidorService) {
    super(new RcmsItem(), rcmsFavorecidoService);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.somenteVisualizar || (this.rcms?.contrato?.id))
      this.usarAtalho = false;
  }

  protected campoFoco() {
    return this.favorecidoInput;
  }

  protected afterInit(): void {
    this.carregarAutoCompletes();
    this.favorecidoEdit = new RcmsFavorecido();
    this.favorecidoEdit.favorecido = new Favorecido();
  }

  protected afterEdit(item: RcmsFavorecido) { }

  protected validSave(item: RcmsFavorecido): boolean {
    if (!item?.favorecido?.id) {
      toastr.warning('Informe o fornecedor!');
      return false;
    }
    if (this.lista) {
      let duplicado = this.lista.find((l) => l.favorecido.id === item.favorecido.id && !l['editavel']);
      if (duplicado) {
        toastr.warning('Fornecedor ja vinculado!');
        return false;
      }
    }
    return true;
  }

  protected validRemover(item: RcmsFavorecido): boolean {
    for (let rcmsItem of this.itens) {
      for (let cotacao of rcmsItem.cotacoes) {
        if (cotacao.valor_unitario > 0 && cotacao?.rcmsFavorecido?.favorecido
          && cotacao.rcmsFavorecido.favorecido.id === item.favorecido.id) {
          toastr.warning(`Fornecedor vinculado a contação, remova a cotação para alterar o fornecedor`);
          return false;
        }
      }
    }
    return true;
  }

  protected beforeSave(item: RcmsFavorecido): void { }



  private carregarAutoCompletes() {
    this.favorecidoAutoComplete = new EddyAutoComplete(null, this.favorecidoService,
      'id', ['nome'], { cidade_id: this.login.cidade.id, orderBy: 'nome' }, { number: ['id', 'cpf_cnpj'], text: ['nome'] }
    );
  }


  // ========================================================================
  // -------------------------- MÉTODOS DA CLASSE ---------------------------
  // ========================================================================

  public editarFavorecido(item: RcmsFavorecido) {
    console.log(item)
    this.favorecidoEdit = item;
    if (!this.favorecidoEdit.favorecido)
      this.favorecidoEdit.favorecido = new Favorecido();
    console.log(this.favorecidoEdit)
    $('#dialogFavorecidoCadastro').modal('show');
  }

  public callbackFavorecido(favorecido: Favorecido) {
    this.favorecidoEdit.favorecido = favorecido;
  }

  public salvarEnterEvent(event, item: RcmsFavorecido) {
    if (event.code === 'Enter')
      this.salvar(item)
  }
}